import { counterModel } from 'APP/model/model';
import { Features } from 'APP/packages/features/Features';
import Entities from 'STORE';

import { addCounters } from '../addCounters/addCounters';
import { loadAllScheduledMessages } from '../loadAllScheduledMessages/loadAllScheduledMessages';
import { loadGroupsByIds } from '../loadGroupsByIds/loadGroupsByIds';

async function loadGroups(counterTs: number | null = null, limit = 20): Promise<number | null> {
  const { items, endPageTs } = await counterModel.getGroupCountersPage(counterTs, limit);

  const groupsIds = items.map((item) => item.groupId);

  await loadGroupsByIds(groupsIds);

  const counters = items
    .filter(({ groupId }) => Entities.GroupsStore.getGroupById(groupId))
    .sort(
      (a, b) =>
        Math.max(b.lastEventTs || 0, b.lastMessageTs || 0, b.seenTs) -
        Math.max(a.lastEventTs || 0, a.lastMessageTs || 0, a.seenTs)
    );

  await addCounters(counters);

  return endPageTs;
}

async function loadMoreGroups(counterTs: number, limit = 100): Promise<void> {
  const endPageTs = await loadGroups(counterTs, limit);

  if (endPageTs) {
    await loadMoreGroups(endPageTs, limit);
  }
}

export async function initGroups(): Promise<void> {
  Entities.GroupsStore.setLoading(true);
  try {
    const endPageTs = await loadGroups(null, 20);

    const promise = endPageTs ? loadMoreGroups(endPageTs) : Promise.resolve();

    promise.finally(() => {
      Entities.GroupsStore.setLoading(false);

      if (Features.isScheduledMessagesEnabled()) {
        loadAllScheduledMessages();
      }
    });
  } catch {
    // reject();
  }
}
